import {
  AccessibilityChecker,
  Category,
  HiddenHeading,
  SocialShareFooter,
  TagsUFs,
  UserHistory,
} from 'govbr.frontend.policy/components';

import {
  HasFieldCondition,
  HasTitleBlockCondition,
  NotContentTypeCondition,
  NotEndingWithCondition,
} from './helpers';

const registerSlotComponents = (config) => {
  // ==================
  // aboveContent
  // ==================

  // Validador de Acessibilidade
  config.registerSlotComponent({
    slot: 'aboveContent',
    name: 'accessibilityChecker',
    component: AccessibilityChecker,
  });

  config.registerSlotComponent({
    slot: 'aboveContent',
    name: 'hiddenHeading',
    component: HiddenHeading,
    predicates: [HasTitleBlockCondition()],
  });

  // ==================
  // belowContent
  // ==================

  // Categoria do conteúdo
  config.registerSlotComponent({
    slot: 'belowContent',
    name: 'category',
    component: Category,
    predicates: [HasFieldCondition('category'), NotEndingWithCondition('/add')],
  });

  // palavras-chave e UFs
  config.registerSlotComponent({
    slot: 'belowContent',
    name: 'TagsUFs',
    component: (props) => <TagsUFs slotView {...props} />,
  });

  // ==================
  // aboveFooter
  // ==================

  // Compartilhamento social
  config.registerSlotComponent({
    slot: 'aboveFooter',
    name: 'socialShare',
    component: SocialShareFooter,
    predicates: [
      NotContentTypeCondition(['Plone Site', 'Link', 'Image', 'File']),
    ],
  });

  // Histórico de navegação
  config.registerSlotComponent({
    slot: 'aboveFooter',
    name: 'userHistory',
    component: UserHistory,
  });

  return config;
};

export default registerSlotComponents;
